/** Student post-login workspace routes (shell + lazy chunks). */
const STUDENT_WORKSPACE_PREFIXES = [
  '/messages',
  '/workspace',
  '/course-materials',
  '/account-settings',
  '/my-tutor',
  '/my-payments',
  '/tutoring-session',
  '/search-results',
  '/subscription',
  '/session-details',
  '/school-profile',
  '/tutor-profile',
  '/written-explanation',
]

/**
 * True for student dashboard / workspace paths that should use
 * WorkspaceShellSkeleton instead of a centered circular spinner.
 */
export function isStudentWorkspacePath(pathname: string): boolean {
  if (pathname === '/support') {
    if (typeof window === 'undefined') return false
    return window.localStorage.getItem('userRole') === 'student'
  }
  return STUDENT_WORKSPACE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  )
}
